import { ITableState, RootState } from '../../../base';

const selectTableStateById = (state: RootState, id: string): ITableState => {
    const table = state.tables[id];
    if (!table) {
        throw new Error(`Table state for id ${id} not found`);
    }
    return table.state;
};

const selectRowsDataById = (
    state: RootState,
    id: string
): Array<Record<string, string>> => {
    const table = state.tables[id];
    if (!table) {
        throw new Error(`Table data for id ${id} not found`);
    }
    return table.data;
};
export const tablesSelectors = {
    getTablesState: selectTableStateById,
    getRowsData: selectRowsDataById,
};
